import {
    Heading,
//    TextField,
    SwitchField,
    Button,
    View,
    Flex,
    Text,
    Loader,
} from "@aws-amplify/ui-react";
import { useState, useEffect } from "react";
import { API, Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";

// New StatusText component replacing the ArchiveIcon
function StatusText({ campaign, toggleArchive }) {
    const [hover, setHover] = useState(false);
    const displayStatus = campaign.status ? "Active" : "Archived";
    const tooltipText =
        displayStatus === "Active"
            ? "Click to set Archived"
            : "Click to set Active";
    return (
        <View
            style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={(e) => { e.stopPropagation(); toggleArchive(campaign); }}
        >
            <Text>{`Status: ${displayStatus}`}</Text>
            {hover && (
                <View
                    as="span"
                    style={{
                        position: "absolute",
                        bottom: "125%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "black",
                        color: "white",
                        padding: "5px",
                        borderRadius: "4px",
                        whiteSpace: "nowrap",
                        zIndex: 10,
                    }}
                >
                    {tooltipText}
                </View>
            )}
        </View>
    );
}

export function Campaigns({
    balance,
    updateBalance,
    subscription,
    clientData,
}) {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(false);
    // New state for switch control
    const [showArchived, setShowArchived] = useState(false);
    const hostname = window.location.hostname;

    useEffect(() => {
        async function fetchCampaigns() {
            setLoading(true);
            try {
                const user = await Auth.currentAuthenticatedUser();
                const request = {
                    headers: {
                        Authorization: `${user.signInUserSession.idToken.jwtToken}`,
                    },
                };
                const resp = await API.get(
                    "gcAPI",
                    `/get-targetedCampaign?userId=${user.username}`,
                    request
                );
                setCampaigns(resp);
            } catch (error) {
                console.error("Error fetching campaigns", error);
            }
            setLoading(false);
        }
        if (subscription && clientData && clientData.subscriptionPlan && (clientData.subscriptionPlan !== "none")) fetchCampaigns();        
        //eslint-disable-next-line
    },[]);

    // Updated toggleArchive to use Active/Archived status
    async function toggleArchive(campaign) {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const newStatus = !campaign.status;
            const request = {
                headers: {
                    Authorization: `${user.signInUserSession.idToken.jwtToken}`,
                },
                body: {
                    action: "archive",
                    campaignId: campaign.SK,
                    status: newStatus,
                },
            };
            const resp = await API.post(
                "gcAPI",
                "/post-updateTargetedCampaign",
                request
            );
            console.log("Status toggle response:", resp);
            setCampaigns((prev) =>
                prev.map((c) =>
                    c.SK === campaign.SK ? { ...c, status: newStatus } : c
                )
            );
        } catch (error) {
            console.error("Error toggling status:", error);
        }
    }

    return (
        <>
            <View align="center">
                <View maxWidth="1000px" align="left">
                    <Heading
                        level={3}
                        fontWeight={"bold"}
                        textAlign="center"
                        color={"#414c5a"}
                        style={{ lineHeight: "1.5" }}
                    >
                        One place to start your
                        <br />
                        LinkedIn Influencer
                        <br />
                        Campaign
                        <br />
                        <br />
                    </Heading>

                    <Flex
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        marginBottom="20px"
                    >
                        <Button
                            variation="primary"
                            size="large"
                            onClick={() => navigate("/newtargetedcampaign")}
                            style={{
                                marginBottom: "10px",
                                padding: "20px 40px",
                            }}
                        >
                            New Targeted Campaign
                        </Button>
                        {(hostname.indexOf('1st-not') > -1) ? "" : (
                        <Button
                            variation="primary"
                            size="large"
                            onClick={() => navigate("/newtestcampaign")}
                            style={{ padding: "5px 10px" }}
                        >
                            New Test Campaign
                        </Button>)}
                        <br />
                    </Flex>

                    {/* Section for Previous Campaigns with Example Elements */}
                    <View>
                    {(hostname.indexOf('1st-not') > -1) ? "" : (
                    <View align="right">
                            <a href="/history">
                            <u>Test Campaigns History</u>
                            </a>
                            </View>)}
                        <Heading level={4}>Previous Targeted Campaigns</Heading>
                        <Flex
                            justifyContent="flex-end"
                            alignItems="center"
                            marginBottom="10px"
                        >
                            {/*<TextField placeholder="Search by name" />*/}
                            <SwitchField
                                label="Show Archived"
                                checked={showArchived}
                                onChange={(e) =>
                                    setShowArchived(e.target.checked)
                                }
                            />
                        </Flex>

                        <Flex direction="column" gap="15px">
                            {loading ? (
                                <Loader variation="linear" />
                            ) : campaigns && campaigns.length ? (
                                campaigns
                                    .filter((camp) => {
                                        const isActive = camp.status
                                            ? true
                                            : false;
                                        return showArchived
                                            ? !isActive
                                            : isActive;
                                    })
                                    .map((camp) => (
                                        <Flex
                                            key={camp.SK}
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            padding="15px"
                                            border="1px solid #ccc"
                                            borderRadius="8px"
                                            onClick={() =>
                                                navigate(
                                                    `/updatetargetedcampaign/${camp.SK.replace(
                                                        "TARGETEDCAMPAIGN ",
                                                        ""
                                                    )}`
                                                )
                                            }
                                        >
                                            <View>
                                                <Heading level={5}>
                                                    {camp.campaignName}
                                                </Heading>
                                                {/*<Text variation="secondary">
                                                    Created on:{" "}
                                                    {camp.createdAt || "N/A"}
                                                </Text>*/}
                                            </View>
                                            <View>
                                                <StatusText
                                                    campaign={camp}
                                                    toggleArchive={
                                                        toggleArchive
                                                    }
                                                />
                                                {camp.budget && parseInt(camp.budget) ?<Text>
                                                    Budget: $
                                                    {camp.budget}
                                                </Text>: ""}
                                            </View>
                                        </Flex>
                                    ))
                            ) : (
                                <Text>No targeted campaigns found.</Text>
                            )}
                        </Flex>
                        {/* Pagination 
                        <View marginTop="20px">
                            <Flex justifyContent="center" gap="10px">
                                <Button variation="link">Previous</Button>
                                <Button variation="link">1</Button>
                                <Button variation="link">2</Button>
                                <Button variation="link">Next</Button>
                            </Flex>
                        </View>
                        */}
                    </View>
                </View>
            </View>
        </>
    );
}
